import { zodResolver } from '@hookform/resolvers/zod';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { PropsWithChildren } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { lpCompany as rules } from 'further-ui/validations';
import { AssetType } from 'further-types/lp/asset';
import { Vehicle } from 'further-types/lp/vehicle';

type Props = {
  selectedVehicle: Vehicle;
  baseCurrency?: CurrencyCode;
  values?: rules.CompanySchemaFormValues;
};

const defaultPortalInformation: rules.PortalInformationSchemaFormValues = {
  description: '',
  companyLogo: null,
  websiteUrl: '',
  twitterUrl: '',
  linkedinUrl: '',
  stage: undefined,
  sector: undefined,
};

export const getDefaultCompany = (
  baseCurrency: CurrencyCode,
): rules.CompanySchemaFormValues => ({
  assetType: AssetType.Company,
  vehicleId: '',
  tradingName: '',
  fullLegalName: '',
  baseCurrency,
  registeredNumber: '',
  registrationCountry: '',
  registeredAddressLine1: '',
  registeredAddressLine2: '',
  registeredAddressTownCity: '',
  registeredAddressPostalCode: '',
  registeredAddressCountry: '',
  ...defaultPortalInformation,
});

const FormWrapper: React.FC<PropsWithChildren<Props>> = ({
  children,
  selectedVehicle,
  values,
}) => {
  const formMethods = useForm<rules.CompanySchemaFormValues>({
    shouldFocusError: true,
    resolver: zodResolver(rules.CompanySchema),
    defaultValues: {
      ...(values ?? getDefaultCompany(selectedVehicle.baseCurrency)),
      vehicleId: selectedVehicle._id,
    },
    criteriaMode: 'all',
    resetOptions: {
      keepDefaultValues: false,
    },
  });
  return <FormProvider {...formMethods}>{children}</FormProvider>;
};

export default FormWrapper;
